export default function() {
  return {
    collectable: {
      owner: "",
      baseURI: "",
      provenanceHash: "",
      whitelist: "",
      isOwner: false,
      saleState: false,
      preSaleState: false,
      totalSupply: 0,
      balance: 0,
      nftWhitelistPrice: 0,
      nftPrice: 0,
      maxNFTClaims: 150,
      nftClaimed: 0,
      userNFTs: [],
      gettingUserNFTs: false,
      breedingState: false,
      breedingPrice: 0,
      NSTsBalance: 0,
    },
    errorMsg: "",
    successMsg: ""
  }
}
